function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { FETCH_CBOOK_SUCCESS } from "../actions";
import initialState from "./initialState";
import defaultSprite from "../../assets/icons/cbi-default.svg";
// HTML To Text Fix #6044
var decodeHTMLEntities = function() {
    var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return str.replace(/&#(\d+);/g, function(match, code) {
        return String.fromCharCode(code);
    });
};
// FIXME: the default sprite can't be loaded by extensions because it
// prepends the asset path with the extension path resulting in a 404.
var getIconURL = function(cbook) {
    return (cbook === null || cbook === void 0 ? void 0 : cbook.icon_set) || defaultSprite;
};
export default function cbook() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.cbook, action = arguments.length > 1 ? arguments[1] : void 0;
    var cbook = _objectSpread({}, action.cbook);
    switch(action.type){
        case FETCH_CBOOK_SUCCESS:
            // Don't save the whole tree, we only ned the node refs, see nodes
            cbook.c = cbook.c.map(function(n) {
                return n.id;
            });
            cbook.name = decodeHTMLEntities(cbook.name);
            // Make sure there's an icon pack to use
            cbook.icon_url = getIconURL(cbook);
            return cbook;
        default:
            return state;
    }
}
